// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_6KnlkActq84vRTeRMCyQ3C"};